module.exports = __webpack_public_path__ + "img/5.9f13ee61.jpg";